export default __webpack_public_path__ + "static/media/blueDownloadArrow.ee49eee7.svg";